import { render } from "./DashboardAddTables.vue?vue&type=template&id=b3110128"
import script from "./DashboardAddTables.vue?vue&type=script&lang=js"
export * from "./DashboardAddTables.vue?vue&type=script&lang=js"

import "./DashboardAddTables.vue?vue&type=style&index=0&id=b3110128&lang=css"

import exportComponent from "/var/www/donorsweb/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__